import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { branch } from 'baobab-react/higher-order'

const SchoolFoundTitle = (props) => {
  const foundText = () => {
    const text = intl.get('search.schools_found', { count: props.totalSchools })
    const foundDetails = [text]

    if (props.params && props.params.study_field) {
      foundDetails.push(intl.get('search_box.for_study_field', { study_field: props.params.study_field }))
    }

    if (props.params && props.params.location) {
      foundDetails.push(intl.get('search_box.in_province', { province: props.params.location }))
    }

    if (props.params && props.params.city) {
      foundDetails.push(intl.get('search_box.in_city', { city: props.params.city }))
    }

    return foundDetails.join(' ')
  }

  return <div className="schools-found">{foundText()}</div>
}

SchoolFoundTitle.propTypes = {
  totalSchools: PropTypes.number,
  params: PropTypes.object,
}

export default branch({
  params: ['serverProps', 'params'],
}, SchoolFoundTitle)
